module.exports = __webpack_public_path__ + "img/crypto-exchange-gold.e44f63ab.svg";